import { PropsWithChildren } from "react";
import {
  LoadingSpinner,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "../../../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { TooltipProvider } from "@radix-ui/react-tooltip";

type Props = PropsWithChildren<{
  onClick: () => void;
  isPending: boolean;
  tooltipText: string;
}>;

export const AddNewRow = ({ onClick, isPending, tooltipText }: Props) => {
  const content = (
    <div
      className={`rounded-2xl border border-gray-1 h-[72px] bg-white overflow-hidden group flex items-center justify-center ${
        isPending
          ? "cursor-not-allowed opacity-50"
          : "hover:cursor-pointer hover:border-2 hover:border-gray-2"
      }`}
      onClick={() => {
        if (!isPending) {
          onClick();
        }
      }}
    >
      <FontAwesomeIcon
        width={10}
        height={10}
        size="sm"
        icon={faCirclePlus}
        className="text-red-3 w-8 h-8 group-hover:scale-150 transition-transform duration-200"
      />
    </div>
  );

  if (isPending) {
    return (
      <div
        className={`rounded-2xl border border-gray-1 h-[72px] bg-white overflow-hidden group flex items-center justify-center ${
          isPending
            ? "cursor-not-allowed opacity-50"
            : "hover:cursor-pointer hover:border-2 hover:border-gray-2"
        }`}
        onClick={() => {
          if (!isPending) {
            onClick();
          }
        }}
      >
        <LoadingSpinner size="x-small" />
      </div>
    );
  }

  return (
    <div>
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>{content}</TooltipTrigger>
          <TooltipContent>
            <div>
              <p>{tooltipText}</p>
            </div>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};

export default AddNewRow;
